export const LANGUAGES = ["EN", "PT", "ES"];

export const translations = {
  EN: {
    nav: { home: "Home", products: "Products", story: "Our Story", recipes: "Recipes",
      whereToBuy: "Where to Buy", trade: "Trade", contact: "Contact",
      tradeLogin: "Trade Login", becomePartner: "Become a Partner" },
    common: { viewProduct: "View Product", viewProducts: "View Products", explore: "Explore",
      readMore: "Read More", loading: "Loading…", search: "Search", filters: "Filters",
      all: "All", category: "Category", storage: "Storage", dietary: "Dietary", brand: "Brand",
      submit: "Submit", cancel: "Cancel", email: "Email", password: "Password",
      apply: "Apply", learnMore: "Learn More", back: "Back", noResults: "No products found",
      tryFilters: "Try changing your filters." },
    home: {
      heroTitle: "Good food brings people together.",
      heroEyebrow: "From Brazil to your table",
      heroSub: "Authentic Brazilian favourites made for everyday life.",
      heroLine: "From Brazil to tables across Europe.",
      exploreBtn: "Explore Sambiva", whereBtn: "Where to Buy", tradeLink: "Trade with Sambiva",
      categoriesTitle: "Everyday Brazilian favourites.",
      categoriesSub: "A pantry of authentic tastes, made simple.",
      featuredTitle: "Meet the Sambiva favourites.",
      featuredSub: "The products our customers reach for again and again.",
      valuesTitle: "Everyday goodness.",
      value1: "Authentic Flavours", value1d: "Recipes true to their Brazilian roots.",
      value2: "Quality Ingredients", value2d: "Carefully sourced, dependably good.",
      value3: "Everyday Goodness", value3d: "Made for real, everyday moments.",
      value4: "Food Brings People Together", value4d: "Shared tables, shared joy.",
      storyTitle: "From Brazil to your table.",
      storyBody: "Brazilian food is about more than ingredients. It is family. Sharing. Comfort. Celebration. Everyday moments around the table. Sambiva brings those familiar tastes into modern homes across Europe.",
      storyBtn: "Discover Our Story",
      recipesTitle: "Make something delicious.",
      recipesSub: "Simple ways to bring Brazil to your kitchen.",
      recipesBtn: "Explore Recipes",
      whereTitle: "Find Sambiva near you.",
      whereSub: "Discover the shops and stores stocking Sambiva across Europe.",
      whereBtn: "Find Sambiva",
      tradeTitle: "Bring more Brazil to your customers.",
      tradeBody: "Retailers, restaurants and online businesses can join Sambiva Trade for wholesale pricing, stock visibility and convenient B2B ordering.",
    },
    footer: { tagline: "Global Flavours, Local Homes", explore: "Explore", company: "Company",
      legal: "Legal", privacy: "Privacy Policy", cookies: "Cookie Policy", terms: "Terms & Conditions",
      rights: "All rights reserved.", trade: "Sambiva Trade", newsletter: "Bringing the taste of Brazil to your table." },
    products: { title: "Our Products", sub: "Explore the full range of Sambiva Brazilian favourites.",
      searchPlaceholder: "Search Sambiva products…", packInfo: "Pack" },
    trade: {
      title: "Brazilian food, built for business.",
      sub: "Sambiva helps retailers, restaurants and online businesses bring authentic Brazilian products to customers across Europe.",
      retailers: "For Retailers", online: "For Online Stores", restaurants: "For Restaurants & Foodservice",
      benefitsTitle: "Why partner with Sambiva",
      cta: "Become a Sambiva Partner", existing: "Existing customer?", loginLink: "Trade Login",
    },
    partner: { title: "Grow with Sambiva.",
      sub: "Join retailers, restaurants and online businesses bringing Brazilian flavours to customers across Europe.",
      fullName: "Full Name", businessType: "Preferred Type of Business", companyName: "Company Name",
      country: "Country", vat: "VAT ID", address: "Address", postcode: "Postcode", phone: "Phone",
      message: "Message", messagePlaceholder: "Tell us about the products you're interested in…",
      gdpr: "I agree that Sambiva may use the information provided to evaluate my trade account application and contact me regarding this enquiry.",
      submit: "Apply for Trade Account",
      success: "Thank you for your interest in Sambiva. Your application has been received and our team will review your business details.",
    },
    contact: { title: "Contact Sambiva", sub: "We'd love to hear from you.",
      fullName: "Full Name", company: "Company", email: "Email", phone: "Phone",
      subject: "Subject", message: "Message", send: "Send Enquiry", success: "Thank you — your enquiry has been sent." },
    login: { title: "Trade Login", sub: "Sign in to your Sambiva trade account.",
      forgot: "Forgot Password?", notPartner: "Not yet a Sambiva trade partner?",
      applyLink: "Apply for a Trade Account", signIn: "Login" },
  },
  PT: {
    nav: { home: "Início", products: "Produtos", story: "A Nossa História", recipes: "Receitas",
      whereToBuy: "Onde Comprar", trade: "Negócios", contact: "Contacto",
      tradeLogin: "Área de Cliente", becomePartner: "Torne-se Parceiro" },
    common: { viewProduct: "Ver Produto", viewProducts: "Ver Produtos", explore: "Explorar",
      readMore: "Ler Mais", loading: "A carregar…", search: "Pesquisar", filters: "Filtros",
      all: "Todos", category: "Categoria", storage: "Armazenamento", dietary: "Dieta", brand: "Marca",
      submit: "Enviar", cancel: "Cancelar", email: "Email", password: "Palavra-passe",
      apply: "Candidatar", learnMore: "Saber Mais", back: "Voltar", noResults: "Nenhum produto encontrado",
      tryFilters: "Tente alterar os filtros." },
    home: {
      heroTitle: "A boa comida une as pessoas.",
      heroEyebrow: "Do Brasil para a sua mesa",
      heroSub: "Os autênticos favoritos brasileiros para o dia a dia.",
      heroLine: "Do Brasil para as mesas de toda a Europa.",
      exploreBtn: "Explorar a Sambiva", whereBtn: "Onde Comprar", tradeLink: "Negócios com a Sambiva",
      categoriesTitle: "Favoritos brasileiros do dia a dia.",
      categoriesSub: "Uma despensa de sabores autênticos, de forma simples.",
      featuredTitle: "Conheça os favoritos Sambiva.",
      featuredSub: "Os produtos que os nossos clientes escolhem sempre.",
      valuesTitle: "Bondade de todos os dias.",
      value1: "Sabores Autênticos", value1d: "Receitas fiéis às raízes brasileiras.",
      value2: "Ingredientes de Qualidade", value2d: "Cuidadosamente selecionados.",
      value3: "Bondade Diária", value3d: "Feito para momentos reais.",
      value4: "A Comida Une as Pessoas", value4d: "Mesas partilhadas, alegria partilhada.",
      storyTitle: "Do Brasil para a sua mesa.",
      storyBody: "A comida brasileira é mais do que ingredientes. É família. Partilha. Conforto. Celebração. Momentos do dia a dia à volta da mesa. A Sambiva traz esses sabores familiares para os lares modernos de toda a Europa.",
      storyBtn: "Conhecer a Nossa História",
      recipesTitle: "Faça algo delicioso.",
      recipesSub: "Formas simples de trazer o Brasil à sua cozinha.",
      recipesBtn: "Explorar Receitas",
      whereTitle: "Encontre a Sambiva perto de si.",
      whereSub: "Descubra as lojas que vendem Sambiva por toda a Europa.",
      whereBtn: "Encontrar Sambiva",
      tradeTitle: "Traga mais Brasil aos seus clientes.",
      tradeBody: "Retalhistas, restaurantes e negócios online podem juntar-se à Sambiva Trade para preços de grosso, visibilidade de stock e encomendas B2B convenientes.",
    },
    footer: { tagline: "Sabores Globais, Lares Locais", explore: "Explorar", company: "Empresa",
      legal: "Legal", privacy: "Política de Privacidade", cookies: "Política de Cookies", terms: "Termos e Condições",
      rights: "Todos os direitos reservados.", trade: "Sambiva Trade", newsletter: "Trazendo o sabor do Brasil à sua mesa." },
    products: { title: "Os Nossos Produtos", sub: "Explore toda a gama de favoritos brasileiros Sambiva.",
      searchPlaceholder: "Pesquisar produtos Sambiva…", packInfo: "Embalagem" },
    trade: {
      title: "Comida brasileira, feita para negócios.",
      sub: "A Sambiva ajuda retalhistas, restaurantes e negócios online a levar produtos brasileiros autênticos aos clientes de toda a Europa.",
      retailers: "Para Retalhistas", online: "Para Lojas Online", restaurants: "Para Restauração",
      benefitsTitle: "Porquê ser parceiro Sambiva",
      cta: "Torne-se Parceiro Sambiva", existing: "Já é cliente?", loginLink: "Área de Cliente",
    },
    partner: { title: "Cresça com a Sambiva.",
      sub: "Junte-se a retalhistas, restaurantes e negócios online que levam sabores brasileiros por toda a Europa.",
      fullName: "Nome Completo", businessType: "Tipo de Negócio", companyName: "Nome da Empresa",
      country: "País", vat: "NIF / VAT", address: "Morada", postcode: "Código Postal", phone: "Telefone",
      message: "Mensagem", messagePlaceholder: "Conte-nos sobre os produtos que lhe interessam…",
      gdpr: "Concordo que a Sambiva utilize a informação fornecida para avaliar a minha candidatura e me contacte sobre este pedido.",
      submit: "Candidatar a Conta de Negócios",
      success: "Obrigado pelo seu interesse na Sambiva. A sua candidatura foi recebida e a nossa equipa irá analisá-la.",
    },
    contact: { title: "Contacte a Sambiva", sub: "Adoraríamos ouvi-lo.",
      fullName: "Nome Completo", company: "Empresa", email: "Email", phone: "Telefone",
      subject: "Assunto", message: "Mensagem", send: "Enviar Pedido", success: "Obrigado — o seu pedido foi enviado." },
    login: { title: "Área de Cliente", sub: "Aceda à sua conta de negócios Sambiva.",
      forgot: "Esqueceu a palavra-passe?", notPartner: "Ainda não é parceiro Sambiva?",
      applyLink: "Candidatar a Conta de Negócios", signIn: "Entrar" },
  },
  ES: {
    nav: { home: "Inicio", products: "Productos", story: "Nuestra Historia", recipes: "Recetas",
      whereToBuy: "Dónde Comprar", trade: "Negocios", contact: "Contacto",
      tradeLogin: "Acceso Clientes", becomePartner: "Hazte Socio" },
    common: { viewProduct: "Ver Producto", viewProducts: "Ver Productos", explore: "Explorar",
      readMore: "Leer Más", loading: "Cargando…", search: "Buscar", filters: "Filtros",
      all: "Todos", category: "Categoría", storage: "Conservación", dietary: "Dieta", brand: "Marca",
      submit: "Enviar", cancel: "Cancelar", email: "Email", password: "Contraseña",
      apply: "Solicitar", learnMore: "Saber Más", back: "Volver", noResults: "No se encontraron productos",
      tryFilters: "Intenta cambiar los filtros." },
    home: {
      heroTitle: "La buena comida une a las personas.",
      heroEyebrow: "De Brasil a tu mesa",
      heroSub: "Auténticos favoritos brasileños para el día a día.",
      heroLine: "De Brasil a las mesas de toda Europa.",
      exploreBtn: "Explorar Sambiva", whereBtn: "Dónde Comprar", tradeLink: "Negocios con Sambiva",
      categoriesTitle: "Favoritos brasileños del día a día.",
      categoriesSub: "Una despensa de sabores auténticos, de forma sencilla.",
      featuredTitle: "Descubre los favoritos Sambiva.",
      featuredSub: "Los productos que nuestros clientes eligen una y otra vez.",
      valuesTitle: "Bondad de cada día.",
      value1: "Sabores Auténticos", value1d: "Recetas fieles a sus raíces brasileñas.",
      value2: "Ingredientes de Calidad", value2d: "Cuidadosamente seleccionados.",
      value3: "Bondad Diaria", value3d: "Hecho para momentos reales.",
      value4: "La Comida Une a las Personas", value4d: "Mesas compartidas, alegría compartida.",
      storyTitle: "De Brasil a tu mesa.",
      storyBody: "La comida brasileña es más que ingredientes. Es familia. Compartir. Confort. Celebración. Momentos cotidianos alrededor de la mesa. Sambiva lleva esos sabores familiares a los hogares modernos de toda Europa.",
      storyBtn: "Descubre Nuestra Historia",
      recipesTitle: "Prepara algo delicioso.",
      recipesSub: "Formas sencillas de traer Brasil a tu cocina.",
      recipesBtn: "Explorar Recetas",
      whereTitle: "Encuentra Sambiva cerca de ti.",
      whereSub: "Descubre las tiendas que venden Sambiva por toda Europa.",
      whereBtn: "Encontrar Sambiva",
      tradeTitle: "Lleva más Brasil a tus clientes.",
      tradeBody: "Minoristas, restaurantes y negocios online pueden unirse a Sambiva Trade para precios mayoristas, visibilidad de stock y pedidos B2B cómodos.",
    },
    footer: { tagline: "Sabores Globales, Hogares Locales", explore: "Explorar", company: "Empresa",
      legal: "Legal", privacy: "Política de Privacidad", cookies: "Política de Cookies", terms: "Términos y Condiciones",
      rights: "Todos los derechos reservados.", trade: "Sambiva Trade", newsletter: "Llevando el sabor de Brasil a tu mesa." },
    products: { title: "Nuestros Productos", sub: "Explora toda la gama de favoritos brasileños Sambiva.",
      searchPlaceholder: "Buscar productos Sambiva…", packInfo: "Paquete" },
    trade: {
      title: "Comida brasileña, hecha para negocios.",
      sub: "Sambiva ayuda a minoristas, restaurantes y negocios online a llevar productos brasileños auténticos a clientes de toda Europa.",
      retailers: "Para Minoristas", online: "Para Tiendas Online", restaurants: "Para Restauración",
      benefitsTitle: "Por qué ser socio de Sambiva",
      cta: "Hazte Socio Sambiva", existing: "¿Ya eres cliente?", loginLink: "Acceso Clientes",
    },
    partner: { title: "Crece con Sambiva.",
      sub: "Únete a minoristas, restaurantes y negocios online que llevan sabores brasileños por toda Europa.",
      fullName: "Nombre Completo", businessType: "Tipo de Negocio", companyName: "Nombre de la Empresa",
      country: "País", vat: "NIF / VAT", address: "Dirección", postcode: "Código Postal", phone: "Teléfono",
      message: "Mensaje", messagePlaceholder: "Cuéntanos sobre los productos que te interesan…",
      gdpr: "Acepto que Sambiva utilice la información facilitada para evaluar mi solicitud y contactarme sobre esta consulta.",
      submit: "Solicitar Cuenta de Negocios",
      success: "Gracias por tu interés en Sambiva. Hemos recibido tu solicitud y nuestro equipo la revisará.",
    },
    contact: { title: "Contacta con Sambiva", sub: "Nos encantaría saber de ti.",
      fullName: "Nombre Completo", company: "Empresa", email: "Email", phone: "Teléfono",
      subject: "Asunto", message: "Mensaje", send: "Enviar Consulta", success: "Gracias — tu consulta ha sido enviada." },
    login: { title: "Acceso Clientes", sub: "Accede a tu cuenta de negocios Sambiva.",
      forgot: "¿Olvidaste la contraseña?", notPartner: "¿Aún no eres socio de Sambiva?",
      applyLink: "Solicitar Cuenta de Negocios", signIn: "Entrar" },
  },
};
